import { type ReactNode, type Ref } from 'react';

interface CollapsibleSectionProps {
  title: string;
  icon: ReactNode;
  /** When true (or undefined/falsy), the section is collapsed */
  collapsed?: boolean;
  onToggle: () => void;
  children: ReactNode;
  /** Extra classes on the content wrapper (default: "px-6 pb-6 pt-4") */
  contentClassName?: string;
  /** Optional ref forwarded to the content wrapper */
  contentRef?: Ref<HTMLDivElement>;
}

export default function CollapsibleSection({
  title,
  icon,
  collapsed,
  onToggle,
  children,
  contentClassName = 'px-6 pb-6 border-t border-steel/10 pt-4',
  contentRef,
}: CollapsibleSectionProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm border-l-4 border-l-orca-elevate border border-steel/10 overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between py-2 px-4 text-left bg-gray-100 hover:bg-gray-200 transition-colors"
      >
        <div className="flex items-center gap-3">
          {icon}
          <span className="text-base font-semibold text-navy">{title}</span>
        </div>
        <svg
          className={`w-5 h-5 text-steel transition-transform duration-200 ${!collapsed ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {!collapsed && (
        <div ref={contentRef} className={contentClassName}>
          {children}
        </div>
      )}
    </div>
  );
}
